import React from "react";
import moment from "moment";
import _ from "lodash";
import classnames from "classnames";
import { FormattedMessage } from "react-intl";

import DetailView from "components/DetailView";
import { getFormatted } from "helpers/formatting";

const DetailsCard = ({ currentItem, onOrderClick, isOrderClickable }) => (
  <DetailView>
    <div className="card-row">
      <div className="card-column">
        <div className="card-item">
          <span className="card-item-label">
            <FormattedMessage id="PURCHASE_TYPE" />
          </span>
          <h3 className="card-item-value">{currentItem.PurchaseType || "-"}</h3>
        </div>
        <div className="card-item">
          <span className="card-item-label">
            <FormattedMessage id="INVOICES_KIND" />
          </span>
          <h3 className="card-item-value">
            {currentItem.InvoiceTypePortal || "-"}
          </h3>
        </div>
        <div className="card-item">
          <span className="card-item-label">
            <FormattedMessage id="PAYMENT_DATE" />
          </span>
          <h3 className="card-item-value">
            {currentItem.PaymentDate
              ? moment(currentItem.PaymentDate).format("DD-MM-YYYY")
              : "-"}
          </h3>
        </div>
        <div className="card-item">
          <span className="card-item-label">
            <FormattedMessage id="INVOICES_AMOUNT_VAT" />
          </span>
          <h3 className="card-item-value">
            {getFormatted(currentItem.InvoiceAmountIncVat, "currency")}
          </h3>
        </div>
        <div className="card-item">
          <span className="card-item-label">
            <FormattedMessage id="INVOICES_COMMISSION" />
          </span>
          <h3 className="card-item-value">
            {getFormatted(currentItem.Commission, "percent")}
          </h3>
        </div>
      </div>
      <div className="card-column">
        <div className="card-item">
          <span className="card-item-label">
            <FormattedMessage id="ORDERS_COVER" />
          </span>
          <h3 className="card-item-value">
            <FormattedMessage id={currentItem.InCoverScheme ? "YES" : "NO"} />
          </h3>
        </div>
        <div className="card-item">
          <span className="card-item-label">
            <FormattedMessage id="ORDERS_NUMBER" />
          </span>
          {_.has(currentItem, "Order.Number") ? (
            <h3
              className={classnames("card-item-value", {
                link: isOrderClickable
              })}
              onClick={isOrderClickable ? onOrderClick : undefined}
            >
              {currentItem.Order.Number}
            </h3>
          ) : (
            <h3>-</h3>
          )}
        </div>
        <div className="card-item">
          <span className="card-item-label">
            <FormattedMessage id="DELIVERIES_END_DATE" />
          </span>
          <h3 className="card-item-value">
            {currentItem.DeliveryDate
              ? moment(currentItem.DeliveryDate).format("DD-MM-YYYY")
              : "-"}
          </h3>
        </div>
        <div className="card-item">
          <span className="card-item-label">
            <FormattedMessage id="ORDERS_PAYMENT" />
          </span>
          <h3 className="card-item-value">
            <FormattedMessage id={currentItem.AdvancePayment ? "YES" : "NO"} />
          </h3>
        </div>
        <div className="card-item">
          <span className="card-item-label">
            <FormattedMessage id="INVOICES_COMMISSION_AMOUNT" />
          </span>
          <h3 className="card-item-value">
            {getFormatted(currentItem.CommissionAmount, "currency")}
          </h3>
        </div>
      </div>
      <div className="card-column">
        <div className="card-item column">
          <span className="card-item-label">
            <FormattedMessage id="COUNTERPARTY" />
          </span>
          <h3 className="card-item-value">
            {`${_.get(currentItem, "CounterParty.Name", "-")}     ${_.get(
              currentItem,
              "CounterParty.Number",
              "-"
            )}`}
          </h3>
          <div className="address">
            <div>
              <span>
                {_.get(
                  currentItem,
                  "CounterParty.PrimaryAddress.Address1",
                  "-"
                )}
              </span>
              <span>
                {`${_.get(
                  currentItem,
                  "CounterParty.PrimaryAddress.ZipCode",
                  "-"
                )}
                  ${_.get(
                    currentItem,
                    "CounterParty.PrimaryAddress.City",
                    "-"
                  )},
                  ${_.get(
                    currentItem,
                    "CounterParty.PrimaryAddress.Country.ISOCode",
                    "-"
                  )}`}
              </span>
            </div>
            <div>
              <span>
                {_.has(currentItem, "CounterParty.OfficeNumber")
                  ? `T. ${currentItem.CounterParty.OfficeNumber}`
                  : "-"}
              </span>
              <span>
                {_.has(currentItem, "CounterParty.FaxNumber")
                  ? `F. ${currentItem.CounterParty.FaxNumber}`
                  : "-"}
              </span>
            </div>
          </div>
          <div className="address">
            <div>
              <span>
                {_.has(currentItem, "CounterParty.MailAddress")
                  ? `E. ${currentItem.CounterParty.MailAddress}`
                  : "-"}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </DetailView>
);

export default DetailsCard;
